import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
} from "../../store/functions";

class PlyAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      formData: {},
      activeTab: 1,
      passedSteps: [1],
      success_msg: false,
      F_PlyMaster: '',
      F_TypeMaster: '',
      Inside: '',
      Outside: '',
      PlyMaster: [],
      TypeMaster: [],
      PaperTypeMaster: [],
      tableRows: [{ particular: "पेपर", inside: "", outside: "" }],
    };
    this.toggleTab = this.toggleTab.bind(this); // Fixed binding
    this.obj = this;
    this.pushFormName = "/PlyAdjustmentMaster"; // Added fallback
    this.formTitle = "Ply Adjustment";
    this.breadCrumbTitle = "Ply Adjustment";
    this.breadCrumbItem = " " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/PlyAdjustment";
    this.API_URL_SAVE = API_WEB_URLS.PlyAdjustmentMaster + "/0/token";
     
    // Initialize PlyData as empty array - will be populated from PlyMaster API
    this.PlyData = [];
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
  }

  async componentDidMount() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    this.setState({});

    //Filling DropDowns
    await Fn_FillListData(
      this.obj,
      "TypeMaster",
      API_WEB_URLS.MASTER + "/0/token/TypeMaster/Id/0"
    );
    await Fn_FillListData(
      this.obj,
      "PlyMaster",
      API_WEB_URLS.MASTER + "/0/token/PlyMaster/Id/0"
    );
    await Fn_FillListData(
      this.obj,
      "PaperTypeMaster",
      API_WEB_URLS.MASTER + "/0/token/PaperTypeMaster/Id/0"
    );

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      const res = await Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
      console.log(res);
      
      // Direct call to process edit data
      if (res ) {
        this.processEditData(res);
      }

    } else {
      this.setState({ id: 0 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.PlyMaster !== this.state.PlyMaster && this.state.PlyMaster.length > 0) {
      console.log("PlyMaster updated:", this.state.PlyMaster);
      
      // Convert PlyMaster data to PlyData format with ID and NoOfPly  
      this.PlyData = this.state.PlyMaster.map(ply => ({
        Id: ply.Id,
        NoOfPly: ply.NoOfPly || 0
      }));
      
      console.log("PlyData populated from PlyMaster:", this.PlyData);
    }
  }

    processEditData = (data) => {
    console.log("Processing edit data:", data);
    
    // Create PlyData from current PlyMaster state
    if (this.state.PlyMaster && this.state.PlyMaster.length > 0) {
      this.PlyData = this.state.PlyMaster.map(ply => ({
        Id: ply.Id,
        NoOfPly: ply.NoOfPly || 0
      }));
      console.log("PlyData created in processEditData:", this.PlyData);
    }
    
    // Find selected ply using F_PlyMaster
    const selectedPly = this.PlyData.find(p => p.Id.toString() == data.F_PlyMaster.toString());
    
    let paperCount = 0;
    let naliCount = 0;
    
    if (selectedPly && selectedPly.NoOfPly) {
      const noOfPly = selectedPly.NoOfPly;
      
      // Same logic as handlePlyChange
      if (noOfPly === 3) {
        paperCount = 2;
        naliCount = 1;
      } else if (noOfPly === 5) {
        paperCount = 3;
        naliCount = 2;
      } else if (noOfPly === 7) {
        paperCount = 4;
        naliCount = 3;
      } else if (noOfPly === 9) {
        paperCount = 5;
        naliCount = 4;
      } else {
        paperCount = Math.ceil(noOfPly / 2);
        naliCount = Math.floor(noOfPly / 2);
      }
    }

    // Create labels array with paper first, then nali
    const labels = [];
    for (let i = 0; i < paperCount; i++) {
      labels.push("पेपर");
    }
    for (let i = 0; i < naliCount; i++) {
      labels.push("नाली");
    }

    // Split comma separated values
    const insideValues = data.InsidePaper ? data.InsidePaper.split(',') : [];
    const outsideValues = data.OutsidePaper ? data.OutsidePaper.split(',') : [];

    // Create tableRows array
    const tableRows = labels.map((label, index) => ({
      particular: label,
      inside: insideValues[index] || '',
      outside: outsideValues[index] || ''
    }));
    console.log("tableRows",tableRows);
    // Update state with all data
    this.setState({
      F_PlyMaster: data.F_PlyMaster.toString(),
      F_TypeMaster: data.F_TypeMaster.toString(),
      formData: {
        F_PlyMaster: data.F_PlyMaster.toString(),
        F_TypeMaster: data.F_TypeMaster.toString(),
        Ply: data.F_PlyMaster.toString(),
        Type: data.F_TypeMaster.toString()
      },
      tableRows: tableRows
    },()=>{
      console.log("tableRows",this.state.tableRows);
    });
  } 

  handleTypeChange = (e) => {
    const value = e.target.value;
    this.setState(prev => ({
      F_TypeMaster: value,  
      formData: { ...prev.formData, Type: value }
    }));
  }
  
  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  handleRowChange = (idx, field, value) => {
    const tableRows = [...this.state.tableRows];
    tableRows[idx][field] = value;
    this.setState({ tableRows });
  };

  handlePlyChange = (e) => {
    const value = e.target.value;
    const selectedPly = this.PlyData.find(p => p.Id.toString() === value);
  
    let paperCount = 0;
    let naliCount = 0;
    
    if (selectedPly && selectedPly.NoOfPly) {
      const noOfPly = selectedPly.NoOfPly;
      
      // Implement the specific logic for paper and nali distribution
      if (noOfPly === 3) {
        paperCount = 2;
        naliCount = 1;
      } else if (noOfPly === 5) {
        paperCount = 3;
        naliCount = 2;
      } else if (noOfPly === 7) {
        paperCount = 4;
        naliCount = 3;
      } else if (noOfPly === 9) {
        paperCount = 5;
        naliCount = 4;
      } else {
        // Default fallback for other values
        paperCount = Math.ceil(noOfPly / 2);
        naliCount = Math.floor(noOfPly / 2);
      }
    } else {
      // Default values if no ply is selected
      paperCount = 1;
      naliCount = 2;
    }
  
    // Create labels array with paper first, then nali
    const labels = [];
    for (let i = 0; i < paperCount; i++) {
      labels.push("पेपर");
    }
    for (let i = 0; i < naliCount; i++) {
      labels.push("नाली");
    }
  
    this.setState(prev => ({
      F_PlyMaster: value,
      formData: { ...prev.formData, Ply: value },
      tableRows: labels.map(label => ({ particular: label, inside: '', outside: '' }))
    }));
  }
  

  btnSave_onClick = (event, formData) => {
    const { tableRows, formData: stateFormData } = this.state;

 // Convert Inside and Outside arrays to comma-separated strings
 const insideValues = tableRows.map(row => row.inside).join(",");
 const outsideValues = tableRows.map(row => row.outside).join(",");
    
    // Create FormData object
    const vformData = new FormData();
    
    // Append all form data with proper field names
    vformData.append("F_PlyMaster", this.state.F_PlyMaster || '');
    vformData.append("F_TypeMaster", this.state.F_TypeMaster || '');
    vformData.append("Inside", insideValues);
    vformData.append("Outside", outsideValues);
     
     // Call API to save data
     Fn_AddEditData(
      this.obj,
      { arguList: { id: this.state.id || 0, formData: vformData } },
      this.API_URL_SAVE,
      this.pushFormName,
      true
  );
    
    // Show success message
    this.setState({ success_msg: true });
  };


//   btnSave_onClick(event, formData) {
   
//     let vformData = new FormData();

//     const insideValues = this.state.tableRows.map(row => row.inside).join(",");
//  const outsideValues = this.state.tableRows.map(row => row.outside).join(",");
    
    
//     vformData.append("F_PlyMaster", formData.F_PlyMaster);
//     vformData.append("F_TypeMaster", formData.F_TypeMaster);
//     vformData.append("Inside", insideValues);
//     vformData.append("Outside", outsideValues);
//     vformData.append("TableName", 'PlyAdjustmentMasterH');
//     vformData.append("Id",this.state.id);
    
   
//     if (!this.state.id)    {
//       Fn_AddEditData(this.obj, { arguList: { id: 0, formData: vformData } }, this.API_URL_SAVE, this.pushFormName, true , "memberid");
   
//     }
//     else
//       Fn_AddEditData(this.obj, { arguList: { id: this.state.id, formData: vformData } }, this.API_URL_SAVE, this.pushFormName, true , "kuku");  

//   }
  

  btnCancel_onClick = event => {
    event.preventDefault();
    this.props.history.push(this.pushFormName);
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        var modifiedSteps = [...this.state.passedSteps, tab];
        this.setState({
          activeTab: tab,
          passedSteps: modifiedSteps,
        });
      }
    }
  }

  render() {
    const { PlyMaster, TypeMaster, PaperTypeMaster, formData, tableRows, F_PlyMaster, F_TypeMaster } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                        <AvForm
                          className="needs-validation"
                          onValidSubmit={this.btnSave_onClick}
                        >
                          <TabContent
                            activeTab={this.state.activeTab}
                            className="body"
                          >
                            <TabPane tabId={1}>
                              <Row>
                                <Col lg="6">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4"></h4>
                                      
                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label
                                            htmlFor="ply"
                                            className="col-form-label"
                                          >
                                            Ply
                                          </label>
                                        </Col>
                                        <Col sm="6">

                                         


                                          <AvField
                                            name="F_PlyMaster"
                                            label=""
                                                value={this.state.formData.F_PlyMaster === null ? ''   : this.state.formData.F_PlyMaster}
                                            errorMessage="Select"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            type="select"
                                            className="form-select"
                                            onChange={this.handlePlyChange}
                                            
                                          >
                                            <option value="">Select</option>
                                            {PlyMaster &&
                                              PlyMaster.map(
                                                option => (
                                                  <option
                                                    key={option.Id}
                                                    value={option.Id}
                                                  >
                                                    {option.Name}
                                                  </option>
                                                )
                                              )}
                                          </AvField>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                                <Col lg="6">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4"></h4>

                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label
                                            htmlFor="type"
                                            className="col-form-label"
                                          >
                                            Type
                                          </label>
                                        </Col>
                                        <Col sm="6">
                                          <AvField
                                            name="F_TypeMaster"
                                            label=""
                                            value={this.state.formData.F_TypeMaster === null ? ''   : this.state.formData.F_TypeMaster}
                                            errorMessage="Select Type"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            type="select"
                                            className="form-select"
                                            onChange={this.handleTypeChange}
                                          >
                                            <option value="">Select</option>
                                            {TypeMaster &&
                                              TypeMaster.map(
                                                option => (
                                                  <option
                                                    key={option.Id}
                                                    value={option.Id}
                                                  >
                                                    {option.Name}
                                                  </option>
                                                )
                                              )}
                                          </AvField>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                              <Row></Row>
                              <Row></Row>
                            </TabPane>
                          </TabContent>
                          {/* Show table only if both Ply and Type are selected */}
                          {formData.Ply && formData.Type && (
                            <Row className="mt-4">
                              <Col lg="12">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>S.No</th>
                                      <th>Particular</th>
                                      <th>Inside Paper Type</th>
                                      <th>Outside Paper Type</th>
                                       
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {tableRows.map((row, idx) => (
                                      <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{row.particular}</td>
                                        <td>
                                          <select
                                            className="form-select"
                                            value={row.inside}
                                            onChange={e => this.handleRowChange(idx, 'inside', e.target.value)}
                                          >
                                            <option value="">Select</option>
                                            {PaperTypeMaster && PaperTypeMaster.map(opt => (
                                              <option key={opt.Id} value={opt.Id}>{opt.Name}</option>
                                            ))}
                                          </select>
                                        </td>
                                        <td>
                                          <select
                                            className="form-select"
                                            value={row.outside}
                                            onChange={e => this.handleRowChange(idx, 'outside', e.target.value)}
                                          >
                                            <option value="">Select</option>
                                            {PaperTypeMaster && PaperTypeMaster.map(opt => (
                                              <option key={opt.Id} value={opt.Id}>{opt.Name}</option>
                                            ))}
                                          </select>
                                        </td>
                                        
                                      </tr>
                                    ))}
                                    
                                  </tbody>
                                </table>
                              </Col>
                            </Row>
                          )}
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              Save
                            </Button>
                            &nbsp;
                            <Button
                              type="button"
                              color="secondary"
                              className="mr-1 waves-effect waves-light"
                              onClick={this.btnGoBack_onClick}
                            >
                              Go Back
                            </Button>

                            {this.state.success_msg && (
                              <SweetAlert
                                title="Saved Successfully!"
                                success
                                confirmBtnBsStyle="success"
                                onConfirm={() => this.setState({ success_msg: false })}
                              >
                                You clicked the button!
                              </SweetAlert>
                            )}
                          </div>
                        </AvForm>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              this.state.activeTab == 1
                                ? "save disabled"
                                : "save"
                            }
                          ></li>
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(container)(PlyAdjustment);
